import i18next from 'i18next';
import I18nXHR from 'i18next-xhr-backend'

const i18n = i18next.use(I18nXHR).init({
  supportedLngs: ['en', 'ru-x-test', 'en-US-x-AgLab-TNTECH','en-GB', 'en-US-x-AgLab'],
  fallbackLng: {
    'en-US-x-AgLab-TNTECH': ['en-US-x-AgLab', 'en'],
    'en-GB': ['en'],
    'ru-x-test': ['ru-x-test'],
    'default': ['en']
  },
  preload: ['en', 'ru-x-test', 'en-US-x-AgLab-TNTECH', 'en-GB'],
  whitelist: ['en', 'ru-x-test', 'en-US-x-AgLab-TNTECH', 'en-GB'],
  ns: 'global',
  debug: false,
  fallbackNS: false,
  backend: {
    loadPath: '/i18n/{{lng}}.json',
  }
}, function (err, t) {
  if (err) return console.error(err)
});

export default i18n



